import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "comments" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classes, (tableClass, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (tableClass === 'expired')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "link pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateExternal()))
            }, [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" > Shop (o.ä.) ", -1),
              _createElementVNode("i", { class: "bi bi-box-arrow-up-right" }, null, -1)
            ]))]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}